import { combineReducers } from 'redux';
import { usersListReducer } from './user-list/user-list.reducer';
import { updateUserReducer } from './update-user/reducer';
import { userDetailsReducer } from './user-details/reducer';
import { createUserReducer } from '../create-user/redux/reducers';

export const usersReducer = combineReducers({
    list: usersListReducer,
    details: userDetailsReducer,
    updateUser: updateUserReducer,
    createUser: createUserReducer
});
